import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Modal from '../../Modal/Modal';
import WorkplaceCalendar from '../../Calendar/WorkplaceCalendar';
import { useAppContext } from '../../../Services/AppContext';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import useTranslation from '../../../Hooks/useTranslation';
import RemoveConfirmationModal from '../../RemoveConfirmation/RemoveConfirmationModal';
import useHealthPlanAppointment from '../../../Modules/HealthPlan/Services/healthPlanAppointment.service';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import CancelButton from '../../Button/CancelButton';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import useHealthPlan from '../../../Modules/HealthPlan/Hooks/useHealthPlan';

interface AppointmentModalProps {
	opened: boolean;
	onClose: any;
	patientId?: string;
	workplaceId?: string;
	healthPlanUserItemId: string;
	allowPickMeetingType?: boolean;
	eventId?: string;
	onEventIsCreated?: () => void;
}

const AppointmentModal: React.FC<AppointmentModalProps> = (
	props: AppointmentModalProps,
) => {
	const {
		opened,
		onClose,
		patientId,
		healthPlanUserItemId,
		allowPickMeetingType = false,
		eventId,
		onEventIsCreated
	} = props;
	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();
	const { getDateRangeByMonth } = useHealthPlanAppointment();
	const { healthPlanUser, activeHealthPlanUserItem, healthPlan } =
		useHealthPlanContext();
	const [isRecommendationModalOpen, setIsRecommendationModalOpen] =
		useState(false);
	const { healthPlanCode } = useHealthPlan();

	useEffect(() => {
		if (healthPlan.code === HealthPlanCode.DIABETES) {
			setIsRecommendationModalOpen(opened);
		}
	}, [opened]);

	const workplaceId = props.workplaceId || useAppContext().workplaceId;

	return (
		<div>
			<Modal
				opened={opened}
				onClose={onClose}
				fullScreen={true}
				wrapChat={isCase}>
				<Modal.Header title={t('component.caseCreate.chooseADateAndTime')} />
				<Modal.Content fullScreen>
					<WorkplaceCalendar
						workplaceId={workplaceId}
						patientId={patientId}
						params={{
							diabetesAppointment: true,
							healthPlanUserItemId: healthPlanUserItemId,
							allowPickMeetingType: allowPickMeetingType,
							eventId,
						}}
						healthPlanCode={healthPlanCode ?? undefined}
						onEventIsCreated={onEventIsCreated}
					/>
				</Modal.Content>
			</Modal>
			<RemoveConfirmationModal
				opened={isRecommendationModalOpen}
				onClose={() => {
					setIsRecommendationModalOpen(false);
				}}
				showAbort={false}
				confirmationTitle={t('component.caseCreate.appointmentRecommendation')}
				confirmationText={t(
					'component.appointmentDetail.meetingHasToBePlannedIn',
					{
						month: getDateRangeByMonth(
							healthPlanUser?.activeFrom
								? moment(healthPlanUser?.activeFrom)
								: moment(),
							activeHealthPlanUserItem?.extra?.month,
						),
					},
				)}
				customButtons={() => (
					<React.Fragment>
						<CancelButton
							onClick={() => setIsRecommendationModalOpen(false)}
							title='base.shared.close'
						/>
					</React.Fragment>
				)}
			/>
		</div>
	);
};

export default AppointmentModal;
